<template>
  <div class="detailMain">
    <div class="returnBtn" @click="goBack()">
      <i class="el-icon-back"></i>
    </div>
    <el-breadcrumb class="crumbs" separator-class="el-icon-arrow-right">
      <el-breadcrumb-item v-for="(item,index)  in routeList" :key="index"
        :to="{ name: item.name,query:{id:item.query.id,flag:item.query.flag,name:item.query.name} }">
        {{item.name}}
      </el-breadcrumb-item>
    </el-breadcrumb>
    <el-card shadow="never">
      <div class="cardTop">
        <h1>{{ detailData.name }}</h1>
        <h2>设备协议</h2>
        <el-dropdown
          v-if="(user_name == 'suadmin' && detailData.type == 1) || (user_name != 'suadmin' && detailData.type != 1)"
          @command="handleCommand">
          <span class="el-dropdown-link">
            操作<i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="edit">编辑</el-dropdown-item>
            <el-dropdown-item command="del">删除</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <div class="cardBottom">
        <el-tabs tab-position="left" style="height: 520px;">
          <el-tab-pane label="详情">
            <h1>协议详情</h1>
            <el-row class="formRow">
              <el-col :span="12">
                <div class="grid-content bg-purple">
                  <label>名称</label> <br />
                  <span>{{ detailData.name }}</span>
                </div>
              </el-col>
              <!-- <el-col :span="12">
                  <div class="grid-content bg-purple">
                    <label>设备离线时间间隔（秒）</label> <br />
                    <span>{{ detailData.offlineInterval!=null?detailData.offlineInterval:"---" }}</span>
                  </div>
                </el-col> -->
              <el-col :span="12">
                <div class="grid-content bg-purple">
                  <label>解析方式</label> <br />
                  <span>{{ getProtocolType(detailData.protocolType) }}</span>
                </div>
              </el-col>
              <el-col :span="24" v-if="detailData.protocolType == 1">
                <div class="grid-content bg-purple">
                  <label>协议脚本</label> <br />
                  <p v-if="detailData.protocolType==1">
                    <el-button type="text" @click="showAnalysisScript = true">查看脚本</el-button>
                  </p>
                  <!--<span>{{ detailData.analysisScriptMd5 }}</span>-->
                  <!--<el-button-->
                  <!--type="text"-->
                  <!--v-if="detailData.analysisScriptAttachmentId"-->
                  <!--@click="download(detailData.analysisScriptAttachmentId)"-->
                  <!--&gt;下载</el-button-->
                  <!--&gt;-->
                  <!--<p v-if="detailData.analysisScriptAttachmentId == null || detailData.analysisScriptAttachmentId==''">无</p>-->
                </div>
              </el-col>
              <el-col :span="24">
                <div class="grid-content bg-purple">
                  <label>协议说明文档</label> <br />
                  <span>{{ detailData.attachmentName }}</span>
                  <el-button v-if="detailData.attachmentId" type="text" @click="download(detailData.attachmentId)">下载
                  </el-button>
                  <p v-if="detailData.attachmentId == null || detailData.attachmentId==''">无</p>
                </div>
              </el-col>
              <!-- <el-col :span="24">
                <div class="grid-content bg-purple">
                  <label>协议使用说明</label> <br />
                  <span>{{
                    detailData.manual != null ? detailData.manual : "---"
                  }}</span>
                </div>
              </el-col> -->
              <el-col :span="24">
                <div class="grid-content bg-purple">
                  <label>备注</label> <br />
                  <span>{{
                      detailData.remarks != null ? detailData.remarks : "---"
                    }}</span>
                </div>
              </el-col>
            </el-row>
            <h1 style="margin-top:30px">系统信息</h1>
            <el-row class="formRow">
              <el-col :span="12">
                <div class="grid-content bg-purple">
                  <label>创建人</label> <br />
                  <span>
                    {{
                      detailData.creator != null ? detailData.creator : "---"
                    }}</span>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="grid-content bg-purple">
                  <label>创建时间</label> <br />
                  <span>{{
                    detailData.createDate != null
                      ? changeDate(detailData.createDate)
                      : "---"
                  }}</span>
                </div>
              </el-col>
            </el-row>
          </el-tab-pane>
          <el-tab-pane label="物模型-上行">
            <h1>
              物模型-上行
              <el-button
                v-if="(user_name == 'suadmin' && detailData.type == 1) || (user_name != 'suadmin' && detailData.type != 1)"
                @command="handleCommand" style="padding:0;float:right" type="text" @click="jumpConfigureInclusion">编辑
              </el-button>
            </h1>

            <el-tabs v-if="uplinkBag.length != 0" class="configTab configTabDetails " v-model="editableTabsValue"
              type="card">
              <el-tab-pane v-for="item in uplinkBag" :key="item.name" :label="item.title" :name="item.name">
                <!-- 包头信息 -->
                <div class="clearfix">
                  <ul class="infoBt clearfix pull-left">
                    <li>
                      <span>功能编码</span><br />
                      <span>{{ item.packet.code }}</span>
                    </li>
                    <li></li>
                  </ul>
                </div>
                <el-table :data="item.content.tableData" border>
                  <el-table-column type="index" label="序号" width="50">
                  </el-table-column>
                  <el-table-column prop="name" label="名称"> </el-table-column>
                  <el-table-column prop="code" label="标识"> </el-table-column>
                  <el-table-column prop="dataType" label="数据类型">
                    <template slot-scope="scope">
                      <span v-if="scope.row.dataType == 1">数值类型</span>
                      <span v-else-if="scope.row.dataType == 2">布尔类型<br>{{scope.row.dataEnum}}</span>
                      <span v-if="scope.row.dataType == 3">字符串</span>
                      <span v-if="scope.row.dataType == 4">16进制</span>
                      <span v-if="scope.row.dataType == 5">枚举类型<br>{{scope.row.dataEnum}}</span>
                      <!-- <span v-html="scope.row.dataType"></span> -->

                    </template>
                  </el-table-column>
                  <el-table-column prop="dataUnit" label="单位">
                  </el-table-column>
                  <el-table-column prop="formula" label="公式">
                  </el-table-column>
                  <el-table-column prop="length" label="长度(字节数)">
                  </el-table-column>
                  <el-table-column prop="storage" :formatter="getStorage" label="是否存储">
                  </el-table-column>
                  <el-table-column prop="fieldDesc" label="说明">
                  </el-table-column>
                </el-table>
              </el-tab-pane>
            </el-tabs>
            <p style="line-height: 45px;font-size: 15px;" v-if="uplinkBag.length == 0">
              暂无数据
            </p>
          </el-tab-pane>
          <el-tab-pane label="物模型-下行" v-if="commuType == 1 || commuType == 3  || commuType == 4">
            <h1>
              物模型-下行
              <el-button
                v-if="(user_name == 'suadmin' && detailData.type == 1) || (user_name != 'suadmin' && detailData.type != 1)"
                @command="handleCommand" style="padding:0;float:right" type="text" @click="jumpDownlinkPackage">编辑
              </el-button>
            </h1>
            <el-tabs v-if="downlinkPackage.length != 0" class="configTab configTabDetails " v-model="editableTabsValue1"
              type="card">
              <el-tab-pane v-for="item in downlinkPackage" :key="item.name" :label="item.title" :name="item.name">
                <!-- 包头信息 -->
                <div class="clearfix">
                  <ul class="infoBt clearfix pull-left">
                    <li>
                      <span>功能编码</span><br />
                      <span>{{ item.packet.code }}</span>
                    </li>
                    <li>
                      <span>下发类型</span><br />
                      <span>{{
                        item.packet.downType == 1
                          ? "下发获取数据"
                          : item.packet.downType == 2
                          ? "下发控制命令"
                          : "---"
                      }}</span>
                    </li>
                    <li v-if="commuType == 3">
                      <span>mqtt topic</span><br />
                      <span>{{
                        item.packet.topic ? item.packet.topic
                          : "---"
                      }}</span>
                    </li>
                    <li v-if="commuType == 3">
                      <span>mqtt qos</span><br />
                      <span>{{
                        item.packet.qos || item.packet.qos === 0 ? item.packet.qos
                          : "---"
                      }}</span>
                    </li>
                    <!-- <li>
                      <span>发送频率（cron表达式）</span><br />
                      <span>{{ item.packet.collectCron }}</span>
                    </li> -->
                  </ul>
                </div>
                <el-table :data="item.content.tableData" border>
                  <el-table-column type="index" label="序号" width="50">
                  </el-table-column>
                  <el-table-column prop="name" label="名称"> </el-table-column>
                  <el-table-column prop="code" label="标识"> </el-table-column>
                  <el-table-column v-if="detailData.protocolType == 2" prop="length" label="长度(字节数)">
                  </el-table-column>
                  <el-table-column prop="fieldType" :formatter="getFieldType" label="下行字段类型">
                  </el-table-column>
                  <el-table-column prop="fieldValue" label="指令值"></el-table-column>
                  <el-table-column prop="fieldDesc" label="说明"></el-table-column>
                </el-table>
              </el-tab-pane>
            </el-tabs>
            <p style="line-height: 45px;font-size: 15px;" v-if="downlinkPackage.length == 0">
              暂无数据
            </p>
          </el-tab-pane>
          <!-- <el-tab-pane label="适配品牌/型号">
            <h1>适配品牌/型号</h1>
            <el-table :data="brandModelData" border>
              <el-table-column prop="brand" label="品牌"> </el-table-column>
              <el-table-column prop="model" label="型号"> </el-table-column>
            </el-table>
          </el-tab-pane> -->
          <el-tab-pane label="关联的设备">
            <h1>关联的设备</h1>
            <el-table :data="subDeviceData" height="450px">
              <el-table-column prop="code" label="设备编号">
                <template slot-scope="scope">
                  <el-button class="tableButton" @click="detailBtn(scope.row.id)">
                    {{ scope.row.code }}</el-button>
                </template>
              </el-table-column>
              <el-table-column prop="name" label="设备名称"> </el-table-column>
              <el-table-column prop="onlineStatus" label="在线状态">
                <template slot-scope="scope">
                  <span v-if="scope.row.onlineStatus == 0">
                    <i class="redDot"></i>离线</span>
                  <span v-else-if="scope.row.onlineStatus == 1">
                    <i class="greenDot"></i>在线</span>
                  <span v-else>---</span>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
        </el-tabs>
      </div>
    </el-card>
    <el-dialog title="协议脚本" :visible.sync="showAnalysisScript" :close-on-click-modal="false"
      :close-on-press-escape="false" :show-close="false">
      <div style="height:300px;">
        <el-button style="position: absolute;margin-top: 5px;z-index: 99;right: 30px;" @click="copyText">复制</el-button>
        <el-input id="analysisScript" type="textarea" :readonly="true" resize="none"
          :autosize="{ minRows: 2, maxRows: 14}" placeholder="脚本内容" v-model="analysisScript">
        </el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="showAnalysisScript = false">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
  import API from "../../api/api";
  import dayjs from "dayjs";
  export default {
    data() {
      return {
        user_name: this.$cookies.get("user_name"),
        commuType: sessionStorage.getItem('commuType'),
        routeList: this.$route.meta.routeList,
        ids: this.$route.query.id,
        // currentPage:1,
        // pageSize:10,
        // total:0,
        editableTabsValue: "1", //默认展示的tab，跟name对应
        editableTabsValue1: "123", //默认展示的tab，跟name对应
        uplinkBag: [], //上行包数据
        downlinkPackage: [], //下行包数据
        detailData: {}, //详情数据
        brandModelData: [], //品牌型号
        subDeviceData: [], //已连接设备
        showAnalysisScript: false, //脚本模态框
        analysisScript: '', //脚本内容
      };
    },
    created() {},
    methods: {

      //格式化时间
      changeDate(time) {

        return dayjs(new Date(time)).format("YYYY-MM-DD HH:mm:ss");
      },

      //协议类型
      getProtocolType(type) {
        switch (type) {
          case 1:
            return "脚本解析";
            break;

          case 2:
            return "模板解析";
            break;

          default:
            return "---";
        }
      },
      //序列化数据类型
      getDataType(row) {
        switch (row.dataType) {
          case 1:
            return "数值类型";
            break;

          case 2:
            return "布尔类型<br>" + row.dataEnum;
            break;

          case 3:
            return "字符串";
            break;
          case 4:
            return "16进制";
            break;
          case 5:
            return "枚举类型";
            break;

          default:
            return "---";
        }
      },

      getFieldType(row) {
        switch (row.fieldType) {
          case 1:
            return "16进制字符串类型";
            break;

          case 2:
            return "地址号";
            break;

          case 3:
            return "16进制和";
            break;

          case 4:
            return "crc校验和";
            break;
          case 5:
            return "动态传入参数类型";
            break;
          case 6:
            return "字符串";
            break;
          case 99:
            return "无";
            break;
          default:
            return "---";
        }
      },
      getStorage(row) {
        switch (row.storage) {
          case 0:
            return "不存储";
            break;

          case 1:
            return "存储";
            break;

          default:
            return "---";
        }
      },
      //获取详情数据
      getPlatformDevProtocolView() {
        API.platformDevProtocolViewDetails(this.ids).then(res => {
          if (res.code == 1) {
            this.detailData = res.data;
            if (res.data.protocolType == 1) {
              var reg = new RegExp('/r/n', "g")
              if (res.data.analysisScript && res.data.analysisScript.length > 0) {
                var text = res.data.analysisScript.replace(reg, '\n');
                this.analysisScript = text;
              }
            }
          }
        });
        //获取物模型-上行
        API.platformDevProtocolViewPacketAndField(this.ids, 1).then(res => {
          // 1代表上行包数据
          if (res.code == 1) {
            this.uplinkBag = res.data;
            if (res.data.length != 0) {
              this.editableTabsValue = res.data[0].name;
            }
          }
        });
        //获取物模型-下行
        API.platformDevProtocolViewPacketAndField(this.ids, 2).then(res => {
          // 2代表下行包数据
          if (res.code == 1) {
            this.downlinkPackage = res.data;
            if (res.data.length != 0) {
              this.editableTabsValue1 = res.data[0].name;
            }
          }
        });
        //根据协议获取品牌型号
        API.platformDevProtocolBrandModel(this.ids).then(res => {
          if (res.code == 1) {
            this.brandModelData = res.data.brandAndModel;
          }
        });
        //根据协议获取所连设备
        API.platformDevProtocolDeviceList(this.ids).then(res => {
          if (res.code == 1) {
            this.subDeviceData = res.data;
          }
        });
      },
      //操作下拉
      handleCommand(para) {
        if (para == "edit") {
          //编辑
          this.$router.push({
            path: "/equipment/equimentProtocolAdd",
            query: {
              id: this.ids,
              flag: "edit"
            }
          });
        } else if (para == "del") {
          //删除
          let para = {
            ids: this.ids
          };
          this.$confirm("此操作将永久删除数据, 是否继续?", "提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning"
            })
            .then(() => {
              API.delPlatformDevProtocolDeviceProtocol(para).then(res => {
                if (res.code == 1) {
                  this.$message.success("删除成功");
                  this.$router.push({
                    path: "/equipment/equipmentProtocolLibrary"
                  });
                } else {
                  var falseList = res.data;
                  var errMsgStr;
                  falseList.forEach(errMsg => {
                    errMsgStr = errMsg.substring(errMsg.indexOf('删除失败'))
                    return;
                  })
                  this.$message.error(errMsgStr);
                }
              });
            })
            .catch(() => {
              this.$message({
                type: "info",
                message: "已取消删除"
              });
            });
        }
      },
      //跳转编辑上行包页面
      jumpConfigureInclusion() {
        this.$router.push({
          path: "/equipment/uplinkPackage",
          query: {
            id: this.ids,
            protocolType: this.detailData.protocolType,
            flag: "edit"
          }
        });
      },
      //跳转编辑下行包页面
      jumpDownlinkPackage() {
        this.$router.push({
          path: "/equipment/downlinkPackage",
          query: {
            id: this.ids,
            protocolType: this.detailData.protocolType,
            flag: "edit"
          }
        });
      },
      //跳转设备详情
      detailBtn(id) {
        this.$router.push({
          path: "/equipment/equipmentDetail",
          query: {
            id: id
          }
        });
      },
      //下载功能
      download(id) {
        let token = this.$cookies.get('access_token');
        let url = id + "&access_token=" + (token ? token : '');
        window.location = API.download(url);
      },
      //复制脚本
      copyText() {
        let text = document.querySelector('#analysisScript');
        text.select(); // 选择对象
        document.execCommand("Copy"); // 执行浏览器复制命令
        this.$message.info('复制成功');
      }
    },
    mounted() {
      this.getPlatformDevProtocolView();
    }
  };

</script>



// WEBPACK FOOTER //
// src/views/platform/equimentProtocolDetails.vue